import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class Messages extends PaginatedStore {
  constructor(scope) {
    super(new Connection('messages', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/messages.js